import request from '../../../../../api/request';

import { RateBasis } from '../shared/rateConversion';

const BASE = '/maintainers-portal/financial-portal/settings/late-interest';

export interface LateInterestRateItem {
  id: number;
  rate: number;
  rateBasis: RateBasis;
  monthlyRate: number;
  dailyRate: number;
  graceDays: number;
  /** null = fila anterior al rework por ítem (rige el setting global). */
  base: AccrualBase | null;
  validFrom: string;
  /** Rige hoy. */
  isActive: boolean;
  /** Su fecha de inicio aún no llega, así que se puede editar o eliminar. */
  isEditable: boolean;
}

export type AccrualBase = 'totalResidual' | 'capitalOnly';

export interface LateInterestOverview {
  rateBasis: RateBasis;
  items: LateInterestRateItem[];
}

export type DateClashCode = 'FUTURE_VALID_FROM_TAKEN' | 'ACTIVE_CONFIG_TODAY';

/** Cuerpo del 409 de choque de fecha: la config vigente para el antes/después. */
export interface LateInterestClashError {
  code: DateClashCode;
  current: LateInterestRateItem;
}

export interface LateInterestPayload {
  rate: number;
  graceDays: number;
  base: AccrualBase;
  validFrom: string;
  /** Confirma el choque de fecha reportado por un 409 previo. */
  confirm?: boolean;
}

export function getLateInterest() {
  return request<LateInterestOverview>(BASE);
}

export function createLateInterestRate(body: LateInterestPayload) {
  return request<LateInterestRateItem>(BASE, { method: 'post', data: body });
}

export function updateLateInterestRate(id: number, body: LateInterestPayload) {
  return request<LateInterestRateItem>(`${BASE}/${id}`, {
    method: 'put',
    data: body,
  });
}

export function deleteLateInterestRate(id: number) {
  return request<void>(`${BASE}/${id}`, { method: 'delete' });
}
